import React from "react";
import { AlertTriangle } from "lucide-react";
import { contractBadge, fmtDate } from "./adminUtils";

export const ContractAlert = ({ employees }) => {
  if (employees.length === 0) return null;
  return (
    <div className="mb-4 bg-amber-50 border border-amber-300 rounded-lg p-4" data-testid="contract-alert">
      <div className="flex items-center gap-2 text-amber-800 font-bold text-[14px] mb-2">
        <AlertTriangle size={16} /> {employees.length} {employees.length === 1 ? "contratto in scadenza" : "contratti in scadenza"}
      </div>
      <div className="flex flex-wrap gap-2">
        {employees.map((e) => {
          const b = contractBadge(e.contract_end);
          return (
            <span key={e.id} className="text-[12px] bg-white border border-amber-200 rounded-full px-2.5 py-1">
              <b className="text-[#16345c]">{e.name}</b>
              {e.is_external && <span className="ml-1 text-[10px] font-bold uppercase text-orange-700">esterno</span>}
              {" · "}
              <span className={b.danger ? "text-red-600 font-semibold" : "text-amber-700 font-semibold"}>{b.label}</span>
              {" "}({fmtDate(e.contract_end)})
            </span>
          );
        })}
      </div>
    </div>
  );
};
